import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import MUIDataTable from 'mui-datatables'
import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import axios from 'axios'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'

class DiwaniyaCategoryList extends React.Component {
  state = {
    data: [],
    isEditingOrderNumber: false,
    editingOrderNumberId: null,
    editingOrderValue: null,
  }

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    var that = this

    await axios
      .get(Constant.getAPI() + '/cruise/list-diwaniya-categories', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          that.setState({
            data: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onOrderNumberEdit = (id, order) => {
    this.setState({
      editingOrderNumberId: id,
      editingOrderValue: order,
      isEditingOrderNumber: true,
    })
  }

  onOrderNumberSave = async () => {
    if (this.state.editingOrderNumberId && this.state.editingOrderValue) {
      await axios
        .put(
          Constant.getAPI() + '/cruise/update-diwaniya-category-status',
          {
            order: this.state.editingOrderValue,
            id: this.state.editingOrderNumberId,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          }
        )
        .then((data) => {
          if (data.status === 200 && data.data) {
            let tempList = this.state.data

            tempList.forEach((item) => {
              if (item.id === this.state.editingOrderNumberId) {
                item.order = this.state.editingOrderValue
              }
            })

            this.setState({
              data: tempList,
              editingOrderNumberId: null,
              editingOrderValue: null,
              isEditingOrderNumber: false,
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      this.setState({
        editingOrderNumberId: null,
        editingOrderValue: null,
        isEditingOrderNumber: false,
      })
    }
  }

  onOrderNumberChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value })
  }

  handleStatusChange = async (id, is_active) => {
    await axios
      .put(
        Constant.getAPI() + '/cruise/update-diwaniya-category-status',
        {
          id,
          is_active,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
            country_short_name: `${localStorage.getItem('countryShortName')}`,
          },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.getData()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          filter: false,
          sort: false,
          display: false,
        },
      },
      {
        name: 'img',
        label: 'Image',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (value) => {
            return (
              <>
                <img
                  src={Constant.getImage() + value}
                  className="img-fluid img-50"
                  alt="img"
                  onError={(event) => {
                    event.currentTarget.src = './assets/images/no_image.png'
                  }}
                />
              </>
            )
          },
        },
      },
      {
        name: 'name_en',
        label: 'Name in English',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'name_ar',
        label: 'Name in Arabic',
        options: {
          filter: false,
          sort: false,
        },
      },
      {
        name: 'order',
        label: 'Order',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[0]
            return (
              <div className="form-group">
                <div className="form-group">
                  {this.state.isEditingOrderNumber && this.state.editingOrderNumberId === id ? (
                    <div className="input-group mb-3">
                      <input
                        type="number"
                        name="editingOrderValue"
                        className="form-control form-control-sm p-l-15"
                        style={{ width: '50px' }}
                        onChange={this.onOrderNumberChange}
                        value={this.state.editingOrderValue}
                      />
                      <div className="input-group-append border">
                        <span
                          onClick={this.onOrderNumberSave.bind(this, id)}
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                        >
                          <i className="f-20 bg-white p-2 icofont icofont-ui-check"></i>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="input-group mb-3">
                      <div
                        className="form-control p-l-15"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                      <div className="input-group-append border">
                        <span
                          onClick={this.onOrderNumberEdit.bind(this, id, order)}
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                        >
                          <i className="f-20 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (is_active, tableMeta) => {
            const id = tableMeta.rowData[0]
            return (
              <Toggle
                id={id}
                checked={is_active ? true : false}
                value={is_active + ''}
                onChange={this.handleStatusChange.bind(this, id, !is_active)}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: false,
          customBodyRender: (id) => {
            return (
              <div>
                <Link
                  to={`/diwaniya-categories/edit/` + id}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Edit"
                >
                  <i className="f-20 icofont icofont-ui-edit text-custom"></i>
                </Link>
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      search: false,
      filter: false,
      print: false,
      download: false,
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSaving ? 'Loading data..!' : 'Sorry, No Data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Addons Category List</h4>
                    </div>
                  </div>
                  <Link
                    to="/diwaniya-categories/add"
                    className="btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger"
                    data-modal="modal-13"
                  >
                    {' '}
                    <i className="icofont icofont-plus m-r-5"></i> Add Addons Category
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Addons Category List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          className="table-responsive"
                          data={this.state.data}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default DiwaniyaCategoryList
